import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { css } from '@emotion/core';
import { UnauthenticatedPaths } from '../constants/Paths';

const SelfRegistrationLink = ({ textLabel, linkLabel, requestStateParams }) => (
    <span
        css={({ linkFontSize }) => css`
            display: flex;
            width: 100%;
            margin-top: 1rem;
            font-size: ${linkFontSize};
            gap: 4px;
            text-align: center;
            justify-content: center;
        `}
    >
        {textLabel}
        <Link
            css={({ blue }) => {
                return css`
                    color: ${blue};
                    text-decoration: none;
                `;
            }}
            to={{ pathname: UnauthenticatedPaths.SELF_REGISTER, search: requestStateParams }}
        >
            {linkLabel}
        </Link>
    </span>
);

SelfRegistrationLink.propTypes = {
    linkLabel: PropTypes.string,
    /**
     * A string representation of request state query parameters
     */
    requestStateParams: PropTypes.string,
    textLabel: PropTypes.string,
};

export default SelfRegistrationLink;
